// CSS-in-JS clone of 'slick-carousel/slick/slick.css':

export const slickStyle = {
  '.slick-slider': {
    position: 'relative',
    display: 'block',
    boxSizing: 'border-box',
    userSelect: 'none',
    touchAction: 'pan-y',
    WebkitTapHighlightColor: 'transparent',
  },
  '.slick-list': {
    position: 'relative',
    display: 'block',
    overflow: 'hidden',
    margin: '0',
    padding: '0',
  },
  '.slick-list:focus': { outline: 'none' },
  '.slick-list.dragging': { cursor: ['pointer', 'hand'] },
  '.slick-slider .slick-track,\n.slick-slider .slick-list': {
    transform: 'translate3d(0, 0, 0)',
  },
  '.slick-track': {
    position: 'relative',
    top: '0',
    left: '0',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  '.slick-track:before,\n.slick-track:after': {
    display: 'table',
    content: "''",
  },
  '.slick-track:after': { clear: 'both' },
  '.slick-loading .slick-track': { visibility: 'hidden' },
  '.slick-slide': {
    display: 'none',
    float: 'left',
    height: '100%',
    minHeight: '1px',
  },
  "[dir='rtl'] .slick-slide": { float: 'right' },
  '.slick-slide img': { display: 'block' },
  '.slick-slide.slick-loading img': { display: 'none' },
  '.slick-slide.dragging img': { pointerEvents: 'none' },
  '.slick-initialized .slick-slide': { display: 'block' },
  '.slick-loading .slick-slide': { visibility: 'hidden' },
  '.slick-vertical .slick-slide': {
    display: 'block',
    height: 'auto',
    border: '1px solid transparent',
  },
  '.slick-arrow.slick-hidden': { display: 'none' },
};
